export enum PAETEPRoleType
{
    Unverified_Users = 1,
    Registered_User = 2,
    Teacher = 22,
    Principal = 23,
    District_Admin = 24,
    NTPE = 103,
    NTPE_Supervisor = 114,
    Nontenured = 116,
    Paraeducator = 122,
    Support_Staff = 125,
    Support_Staff_Supervisor = 126,
    Building_Lead = 998,
    Super_Admin = 999
}